<template>
  <div class="container">
    <div class="minu" id="jump0">
      <div class="head">
        <div class="headLogo" @click="$router.push('/')">
          <img class="headLogo_img" src="../../static/img/logoname.png" alt="" />
        </div>
        <div class="headMinu">
          <div class="headAbout">
            <div :class="index == 1 ? 'headAbout_text' : 'headAbout_textTwo'" @click="goFn(1)">О нас</div>
            <div :class="index == 2 ? 'headAbout_text' : 'headAbout_textTwo'" @click="goFn(2)">Как его получить?</div>
            <div :class="index == 3 ? 'headAbout_text' : 'headAbout_textTwo'" @click="goFn(3)">Лицензия на МФО</div>
          </div>
          <div class="headLang">
            <div class="headLang_e">QZ</div>
            <div class="headLang_h">RU</div>
          </div>
          <!-- <div class="head_btn" @click="getlogin">Bойти</div> -->
        </div>
        <div class="ut">Mfo Eckz, Too</div>
      </div>
    </div>

    <!-- 介绍  -->
    <div class="introduce">
      <div class="introduce_title">О компании</div>
      <div class="introduce_text">Познакомитесь с нами</div>
      <div class="introduce_text">Mfo Eckz, Too</div>
    </div>

    <!-- 内容 -->
    <div class="cont">
      <div class="cont_title">Кто мы</div>
      <div class="cont_min">
        <img class="cont_min-img" src="../../static/img/gy.png" alt="" />
        <div class="cont_min-co">
          Быстрый займ - это бренд онлайн-микрофинансовых услуг, которыми может воспользоваться каждый.Услуга позволяет вам решить финансовые проблемы через мобильный телефон за несколько минут, не выходя из дома, без залога и гарантий.<br />
          <span class="cont_min-co-span" @click="documentFn">Лицензия на осуществление микрофинансовой деятельности</span>
        </div>
      </div>
    </div>

    <!-- 我们的愿望 -->
    <div class="desire">
      <div class="desire_title wow animate__fadeInDown">Наше желание</div>
      <div class="desire_text wow animate__fadeInUp">Мы предоставляем быстрые кредиты, ориентированы на клиента, предоставляем оптимальные условия и разумные процентные ставки, а также используем современные технологии для упрощения процесса и обеспечения эффективности и удобства.</div>
      <div class="desire_text wow animate__fadeInUp">Мы ценим доверие клиентов и стремимся строить долгосрочные отношения. Каждый клиент – не только заемщик, но и партнер нашего для финансового успеха.</div>
      <img class="desire_img wow animate__fadeInRight" src="../../static/img/jg.png" alt="" />
    </div>

    <!-- 底部 -->
    <div class="bom">
      <div class="bom_title">Mfo Eckz, Too</div>
      <img class="bom_bg" src="../../static/img/d.png" alt="" />
      <div style="display: flex;justify-content: space-between;">
        <div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/tel.png" alt="" />
            <div class="bom_min-textpj">+7 775 030 86 86</div>
          </div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/wa.png" alt="" />
            <div class="bom_min-textpj">+{{WhatsAppphone}}</div>
          </div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/time.png" alt="" />
            <div class="bom_text">Пн-Пт 10:00-19:00 Сб, Вс выходные</div>
          </div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/email.png" alt="" />
            <div class="bom_min-text-two">info@mfoeckz.com</div>
          </div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/add.png" alt="" />
            <div class="bom_min-two">Казахстан, город Алматы, Бостандыкский район,улица Еділ Ерғожин, здание 27, 46
            </div>
          </div>
        </div>

        <div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;margin-top: 0.08rem;" @click="$router.push('/')">Главная страница</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="homeFn(0)">О нас</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="goFn(2)">Как его получить?</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="goFn(3)">документ</div>
        </div>

        <div>
          <div class="bom_text-two">Скачивай мобильное приложение через:</div>
          <div class="bomIMg" style="margin-bottom: 0.25rem">
            <img class="bom_img" style="margin-right: 0.1rem;" src="../../static/img/googleplay.png" alt="" @click="googleFn" />
            <img class="bom_img" src="../../static/img/AppStore.png" alt=""  @click="appstoreFn" />
          </div>
          <div class="payment_minu">
            <img class="payment_minu-img" style="margin-right: 0.1rem;" src="/static/img/mastercar.png" alt="" />
            <img class="payment_minu-img" src="/static/img/visa.png" alt="" />
          </div>
        </div>
      </div>

    <!-- 支付相关 -->
    <div class="payment">
        <div class="payment-line"></div>
        <div class="payment_text">ТОО «МФО ECKZ», Лицензия на осуществление микрофинансовой деятельности № 02.24.0011.М,
          от 12.09.2024 года, выдана Управлением региональных представителей в городе Алматы Агентства Республики
          Казахстан по регулированию и развитию финансового рынка.</div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import {
    cfgIndex
  } from '@/api/info'
  import { WOW } from 'wowjs'
  export default {
    name: "about",
    data() {
      return {
        index: 1,
        WhatsAppphone: ''
      };
    },
    created() {
      this.cfgIndexfn()
    },
    mounted() {
      document.querySelector("#jump" + 0).scrollIntoView(true);
      this.$nextTick(() => {
          // 保存实例到组件实例中，方便后续调用
          this.wowInstance = new WOW({
            boxClass: 'wow',
            animateClass: 'animate__animated', // 注意：Animate.css v4+ 类名前缀是 animate__
            offset: 0,
            mobile: true,
            live: true
          });
          this.wowInstance.init(); // 初始化
          this.wowInstance.sync();
        });
    },
    methods: {
      // 获取全局配置
      cfgIndexfn(){
        cfgIndex().then(res => {
          let WhatsAppphone = res.data.data.WhatsAppphone
          this.WhatsAppphone = WhatsAppphone.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1 $2 $3 $4');
        })
      },
       goFn(type) {
        this.index = type
        if (type == 1) {
          this.$router.push('/about')
        } else if(type == 2){
          this.$router.push('/tutorial')
        }else{
          this.$router.push('/document')
        }
      },
      homeFn(index) {
        if (index == 0) {
          document.querySelector("#jump" + index).scrollIntoView(true);
        }
      },
      getlogin() {
        this.$router.push('/login')
      },
      googleFn() {
        location.href =
          'https://play.google.com/store/apps/details?id=express.credit.fast.tez.loan.money.cash.pay.bank.card'
      },
      documentFn() {
        location.href = 'https://mfoeckz.com/MFOlicense.pdf'
      },
      appstoreFn() {
        location.href = 'https://apps.apple.com/kz/app/%D0%B1%D1%8B%D1%81%D1%82%D1%80%D1%8B%D0%B9-%D0%B7%D0%B0%D0%B9%D0%BC/id6751275518'
      }
    },
  };
</script>

<style scoped>
  *{
    margin: 0;
    padding: 0;
  }
  .head {
    padding: 0.1rem 0.8rem 0 1.88rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .headLogo {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.1rem;
  }

  .headLogo_img {
    width: 1.22rem;
    height: 0.27rem;
    cursor: pointer;
  }

  .headLogo_title {
    width: 0.41rem;
    height: 0.19rem;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.08rem;
    color: #0aba08;
    font-style: normal;
  }

  .headMinu {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 0.77rem;
    margin-right: 0.44rem;
  }

  .headAbout {
    width: 100%;
    height: 0.23rem;
    line-height: 0.43rem;
    border-radius: 0.11rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.27rem 0.1rem;
    margin-right: 0.45rem;
  }

  .headAbout_text {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #333333;
    font-style: normal;
    border-bottom: 0.03rem solid #D4AF37;
    cursor: pointer;
  }

  .headAbout_textTwo {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #999999;
    font-style: normal;
    cursor: pointer;
    margin-bottom: 0.03rem;
  }

  .headAbout_textTwo:hover {
    color: #4C9F70;
  }

  .headLang {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 0.29rem;
  }

  .headLang_e {
    width: 0.17rem;
    height: 0.17rem;
    line-height: 0.17rem;
    border-radius: 0.02rem;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #fff;
    font-style: normal;
    margin-right: 0.07rem;
  }

  .headLang_h {
    width: 0.17rem;
    height: 0.17rem;
    line-height: 0.17rem;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #fff;
    font-style: normal;
  }

  .head_btn {
    width: 0.75rem;
    height: 0.23rem;
    line-height: 0.23rem;
    text-align: center;
    background: #D4AF37;
    border-radius: 0.11rem;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.08rem;
    color: #FFFFFF;
    font-style: normal;
    cursor: pointer;
  }

  .ut{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.1rem;
  }

  .introduce {
    height: 1.3rem;
    background-color: #0ABA08;
    background-image: url(../../static/img/abou.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding-left: 1.88rem;
    padding-top: 0.78rem;
  }
  .introduce_title{
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.26rem;
    color: #FFFFFF;
    font-style: normal;
    margin-bottom: 0.1rem;
    animation: backInLeft;
    animation-duration: 2s;
  }
  .introduce_text{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #CDF0CC;
    font-style: normal;
    animation: backInLeft;
    animation-duration: 2s;
  }

  .cont{
    padding: 0.73rem 1.87rem;
  }
  .cont_title{
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.22rem;
    color: #333333;
    text-align: center;
    font-style: normal;
    margin-bottom: 0.52rem;
    animation: fadeInDown;
    animation-duration: 2s;
  }
  .cont_min{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .cont_min-img{
    width: 2.52rem;
    height: 1.93rem;
    animation: fadeInLeft;
    animation-duration: 2s;
  }
  .cont_min-co{
    width: 3.19rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #666666;
    line-height: 0.21rem;
    font-style: normal;
    animation: fadeInRight;
    animation-duration: 2s;
  }
  .cont_min-co-span{
    color: #4C9F70;
    text-decoration-line: underline;
    cursor: pointer;
  }
  .desire{
    background: #F9F9F9;
    padding: 0.68rem 0 0.57rem;
    position: relative;
  }
  .desire_title{
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.22rem;
    color: #333333;
    text-align: center;
    font-style: normal;
    margin-bottom: 0.42rem;
  }
  .desire_text{
    width: 5.32rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.13rem;
    color: #666666;
    line-height: 0.21rem;
    font-style: normal;
    margin: 0 auto 0.21rem;
  }
  .desire_img{
    width: 1.69rem;
    height: 1.25rem;
    position: absolute;
    bottom: 0.21rem;
    right: 0.57rem;
  }
 .bom {
   padding: 0.44rem 1.96rem 0.24rem 1.88rem;
   background-color: #FFFFFF;
   position: relative;
 }
 .bom_bg{
   width: 2.6rem;
   height: 1.81rem;
   position: absolute;
   bottom: 0;
   left: 0;
 }
 .bom_title{
   font-family: Roboto, Roboto;
   font-weight: bold;
   font-size: 0.18rem;
   color: #333333;
   font-style: normal;
   margin-bottom: 0.27rem;
 }
 .bom_titletw{
   font-family: Roboto, Roboto;
   font-weight: bold;
   font-size: 0.18rem;
   color: #333333;
   font-style: normal;
   margin-bottom: 0.08rem;
 }
 .bom_min{
   display: flex;
   flex-direction: row;
   align-items: center;
   margin-bottom: 0.2rem;
 }
 .bom_min-img{
   width: 0.23rem;
   height: 0.23rem;
   margin-right: 0.11rem;
 }
 .bom_min-textpj{
   font-family: Roboto, Roboto;
   font-weight: bold;
   font-size: 0.09rem;
   color: #333333;
   font-style: normal;
 }
 .bom_min-text{
   font-family: Roboto, Roboto;
   font-weight: bold;
   font-size: 0.09rem;
   color: #333333;
   font-style: normal;
   cursor: pointer;
 }
 .bom_min-text-two{
   font-family: Roboto, Roboto;
   font-weight: 400;
   font-size: 0.09rem;
   color: #333333;
   font-style: normal;
 }
 .bom_min-two{
   width: 2.17rem;
   font-family: Roboto, Roboto;
   font-weight: 400;
   font-size: 0.09rem;
   color: #333333;
   line-height: 0.13rem;
   font-style: normal;
 }
 .bom_text {
   width: 0.88rem;
   font-family: Roboto, Roboto;
   font-weight: 400;
   font-size: 0.09rem;
   color: #333333;
   line-height: 0.13rem;
   font-style: normal;
 }
 .bom_texte{
   font-family: Roboto, Roboto;
   font-weight: 400;
   font-size: 0.1rem;
   color: #06B804;
   margin-bottom: 0.09rem;
   font-style: normal;
 }

 .bom_text-two {
  width: 1.06rem;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 0.09rem;
  color: #666666;
  line-height: 0.13rem;
  font-style: normal;
  margin-bottom: 0.1rem;
 }
 .bomIMg {
   display: flex;
   flex-direction: row;
   align-items: center;
 }

 .bom_img {
   width: 0.71rem;
   height: 0.21rem;
   cursor: pointer;
 }

 .payment {
   padding-right: 0.5rem;
   margin-top: 0.2rem;
 }
 .payment-line{
   width: 6.24rem;
   height: 0.01rem;
   background: #E3E3E3;
   margin-bottom: 0.2rem;
 }
 .payment_text {
   width: 5.46rem;
   font-family: Roboto, Roboto;
   font-weight: 400;
   font-size: 0.07rem;
   color: #5C5C5C;
   line-height: 0.13rem;
   font-style: normal;
 }

 .payment_minu {
   width: 1rem;
   display: flex;
   justify-content: space-between;
   align-items: center;
 }

 .payment_minu-img {
   width: 0.49rem;
   height: 0.31rem;
 }
</style>



// WEBPACK FOOTER //
// src/components/about.vue